'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DateLabel(_ref) {
  var text = _ref.text;

  return _react2.default.createElement(
    'span',
    { className: 'text-center m-y-2' },
    _react2.default.createElement(
      'p',
      { className: 'm-bottom-0' },
      _react2.default.createElement(
        _Small2.default,
        { use: 'help' },
        text
      )
    )
  );
}

DateLabel.propTypes = {
  text: _react.PropTypes.string.isRequired
};

exports.default = DateLabel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.133/js/components/labels/DateLabel.js
// module id = 407
// module chunks = 0 1